import { render } from "./VenuesDataTable.vue?vue&type=template&id=53a2d35a&scoped=true&ts=true"
import script from "./VenuesDataTable.vue?vue&type=script&lang=ts"
export * from "./VenuesDataTable.vue?vue&type=script&lang=ts"

import "./VenuesDataTable.vue?vue&type=style&index=0&id=53a2d35a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a2d35a"]])

export default __exports__